import { Info } from "lucide-react";

const RequirementFormSection = ({ ctx }) => {
  const {
    closeDialog,
    editingRequirement,
    handleRequirementSubmit,
    materials,
    requirementForm,
    requirements,
    setRequirementForm
  } = ctx;
  return (
    <>
            <form onSubmit={handleRequirementSubmit} className="space-y-4 mt-4">
              <div>
                <label className="block text-xs font-medium text-slate-700 mb-2 uppercase tracking-widest">Material *</label>
                {editingRequirement ? (
                  // Show material name as read-only when editing
                  <div className="w-full px-4 py-2 border border-slate-200 rounded-sm bg-slate-50 text-slate-700">
                    {editingRequirement.material_name} ({materials.find(m => m.id === editingRequirement.material_id)?.unit || ''})
                  </div>
                ) : (
                  <select
                    required
                    value={requirementForm.material_id}
                    onChange={(e) => setRequirementForm({ ...requirementForm, material_id: e.target.value })}
                    data-testid="requirement-material-select"
                    className="w-full px-4 py-2 border border-slate-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-primary"
                  >
                    <option value="">Select Material</option>
                    {materials.filter(m => !requirements.find(r => r.material_id === m.id)).map(mat => (
                      <option key={mat.id} value={mat.id}>{mat.name} ({mat.unit})</option>
                    ))}
                  </select>
                )}
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-medium text-slate-700 mb-2 uppercase tracking-widest">Planned Quantity *</label>
                  <input
                    type="number"
                    required
                    step="0.01"
                    value={requirementForm.planned_quantity}
                    onChange={(e) => setRequirementForm({ ...requirementForm, planned_quantity: e.target.value })}
                    data-testid="requirement-quantity-input"
                    className="w-full px-4 py-2 border border-slate-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-primary font-mono"
                    placeholder="Total planned quantity"
                  />
                </div>
                <div className="flex items-center pt-6">
                  <input
                    type="checkbox"
                    id="is_lumpsum"
                    checked={requirementForm.is_lumpsum}
                    onChange={(e) => setRequirementForm({ ...requirementForm, is_lumpsum: e.target.checked })}
                    className="w-4 h-4 text-primary border-slate-300 rounded focus:ring-primary"
                  />
                  <label htmlFor="is_lumpsum" className="ml-2 text-sm text-slate-700">
                    Lumpsum Item <span className="text-slate-500">(flexible quantity)</span>
                  </label>
                </div>
              </div>
              
              <div className="p-4 bg-blue-50 border border-blue-200 rounded-sm">
                <h4 className="text-sm font-medium text-blue-800 mb-3 flex items-center">
                  <Info className="w-4 h-4 mr-2" />
                  Rate Management (Management Approved)
                </h4>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs font-medium text-slate-700 mb-2 uppercase tracking-widest">Management Rate (₹)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={requirementForm.management_rate}
                      onChange={(e) => setRequirementForm({ ...requirementForm, management_rate: e.target.value })}
                      className="w-full px-4 py-2 border border-slate-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-primary font-mono"
                      placeholder="Leave blank if not fixed"
                    />
                    <p className="text-xs text-slate-500 mt-1">Approved rate by management. Leave blank to allow data enterer to set rate.</p>
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-slate-700 mb-2 uppercase tracking-widest">Allowed Variance (%)</label>
                    <input
                      type="number"
                      step="0.1"
                      value={requirementForm.rate_variance_allowed}
                      onChange={(e) => setRequirementForm({ ...requirementForm, rate_variance_allowed: e.target.value })}
                      className="w-full px-4 py-2 border border-slate-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-primary font-mono"
                      placeholder="3"
                    />
                    <p className="text-xs text-slate-500 mt-1">Data enterer can vary rate by this %. Beyond this needs approval.</p>
                  </div>
                </div>
              </div>
              
              <div>
                <label className="block text-xs font-medium text-slate-700 mb-2 uppercase tracking-widest">Remarks</label>
                <textarea
                  value={requirementForm.remarks}
                  onChange={(e) => setRequirementForm({ ...requirementForm, remarks: e.target.value })}
                  className="w-full px-4 py-2 border border-slate-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-primary"
                  rows="2"
                  placeholder="Optional notes"
                />
              </div>
              <div className="flex justify-end space-x-3 pt-4">
                <button type="button" onClick={closeDialog} className="btn-outline">Cancel</button>
                <button type="submit" data-testid="submit-requirement-button" className="btn-primary">
                  {editingRequirement ? 'Update Requirement' : 'Add Requirement'}
                </button>
              </div>
            </form>
    </>
  );
};

export default RequirementFormSection;
